import React from 'react';
import { styled } from '@mui/material/styles';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { getTextContentHeading } from '../ChapterList';

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#F45B69',
        color: theme.palette.common.white,
        fontWeight: 700,
        border: `1px solid ${borderColor}`,
        verticalAlign: 'baseline',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: '#555555',
        border: `1px solid ${borderColor}`,
        verticalAlign: 'baseline',
    },
    '&.bold-text': {
        fontWeight: 700,
    },
    '&:first-child': {
        borderLeft: `1px solid ${specialBorderColor}`,
    },
    '&:last-child': {
        borderRight: `1px solid ${specialBorderColor}`,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#CCE5E5",
    },
}));

const listData = {
    data: [
        "Desktop, Laptop, mobile devices with internet connectivity and printer; ",
        "Device ensuring uninterrupted power supply; ",
        "Camera; ",
        "Microphones and speakers; ",
        "Display unit / screen; ",
        "Document visualizer; ",
        "Provision of a firewall; ",
        "Adequate seating arrangements ensuring privacy;",
        "Adequate lighting; and ",
        "Availability of a quiet and secure space.",
    ]
}

const ConferenceRoomTable = () => {
    return (
        <TableContainer sx={{ width: "100%" }}>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell>Section</StyledTableCell>
                        <StyledTableCell>Section Title</StyledTableCell>
                        <StyledTableCell>Details</StyledTableCell>
                        <StyledTableCell>Design Considerations</StyledTableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    <StyledTableRow>
                        <StyledTableCell colSpan={4} sx={{ fontWeight: "bold", textAlign: "center" }}>Model Video Conferencing Rules</StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>S. 4. </StyledTableCell>
                        <StyledTableCell>Facilities recommended for Video Conferencing</StyledTableCell>
                        <StyledTableCell>
                            The following equipment is recommended for conducting proceedings by video conferencing at the Court Point and at the Remote Point:
                            <br /><br />
                            (i) Desktop, Laptop, mobile devices with internet connectivity and printer;
                            <br /><br />
                            (ii) Device ensuring uninterrupted power supply;
                            <br /><br />
                            (iii) Camera;
                            <br /><br />
                            (iv) Microphones and speakers;
                            <br /><br />
                            (v) Display unit;
                            <br /><br />
                            (vi) Document visualizer;
                            <br /><br />
                            (vii) Provision of a firewall;
                            <br /><br />
                            (viii) Adequate seating arrangements ensuring privacy;
                            <br /><br />
                            (ix) Adequate lighting; and
                            <br /><br />
                            (x) Availability of a quiet and secure space

                        </StyledTableCell>
                        <StyledTableCell>
                            All Conference Rooms and Training Rooms must be equipped with the necessary technology and equipment to facilitate video-conferencing, remote display of evidence, and voice recording, including:
                            {getTextContentHeading(listData, true)}
                        </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell colSpan={4} sx={{ fontWeight: "bold", textAlign: "center" }}>Model Live Streaming Rules</StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <StyledTableCell>S.11.</StyledTableCell>
                        <StyledTableCell>Dedicated room(s) for live streaming</StyledTableCell>
                        <StyledTableCell>
                            In order to decongest the court rooms, dedicated room(s) for viewing the live stream may be made available within the court premises. Access shall be given to law researchers, staff, litigants, academicians, and media personnel authorised to enter the court premises upon receipt of necessary permissions/approvals. Appropriate arrangements shall be made to enable viewing of live streams multiple benches within this/these room(s). Special arrangements will be made for differently abled persons.
                        </StyledTableCell>
                        <StyledTableCell>
                            The Training Rooms may be used to view live streaming proceedings for authorised persons.
                            <br />
                            Training Rooms must be accessible to all diverse users.
                        </StyledTableCell>
                    </StyledTableRow>

                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default ConferenceRoomTable;
